"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSchedule = validateSchedule;
function validateSchedule(ctx, obj, booleanField, dateField) {
    const isScheduled = Boolean(obj[booleanField]);
    const scheduledValue = obj[dateField];
    if (isScheduled) {
        if (!scheduledValue) {
            ctx.addIssue({
                path: [dateField],
                code: 'custom',
                message: 'Scheduled time is required',
            });
            return;
        }
        const dt = new Date(String(scheduledValue));
        if (Number.isNaN(dt.getTime())) {
            ctx.addIssue({
                path: [dateField],
                code: 'custom',
                message: 'Invalid date format',
            });
            return;
        }
        if (dt <= new Date()) {
            ctx.addIssue({
                path: [dateField],
                code: 'custom',
                message: 'Scheduled time must be in the future',
            });
        }
    }
    else if (scheduledValue != null) {
        ctx.addIssue({
            path: [dateField],
            code: 'custom',
            message: 'Remove scheduled time when not scheduling',
        });
    }
}
